import React from 'react'
import { Link } from 'react-router-dom'
import Constant, { getCountryTimeZone, getTypeTags } from '../../Constant'
import Swal from 'sweetalert2'
import axios from 'axios'
import MUIDataTable from 'mui-datatables'
import { write, utils } from 'xlsx'
import CustomFooter from '../../common/TableBottom'
import Moment from 'react-moment'
import moment from 'moment'
import Select from 'react-select'
import Button from '../../common/CustomComponents/Button'
import Loader from '../../common/Loader'
moment.tz = require('moment-timezone')

class NewEventList extends React.Component {
  state = {
    model: false,
    booked_by_userId: '',
    open: false,
    limit: 10,
    pageNumber: 0,
    disabled: false,
    eventData: [],

    eventList: [],
    country_list: [],

    // Filters
    customer_phone: '',
    keyword: '',
    eventId: null,
    bookingStatus: '',
    country: '',
    type_tag: '',
    booking_date: null,

    isSearching: false,
    totalCount: 0,
    totalPages: 0,
  }

  debounceTimeout = null

  componentDidMount() {
    this.eventListData()
    this.getCountries()
  }

  componentWillUnmount() {
    // Clear timeout on unmount
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }
  }

  getEventList = async (country) => {
    var that = this
    await axios
      .get(Constant.getAPI() + '/event/list-events', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: {
          country: country,
          isActive: 'true',
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          that.setState({
            eventList: res?.data?.data?.map((itm) => ({
              label: `${itm.event_name_en}/${itm.event_name_ar}`,
              value: itm.id,
            })),
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getCountries = async () => {
    await axios
      .get(Constant.getAPI() + '/multi-country/list-countries?show_all_countries=true', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name:
            localStorage.getItem('loged_In_role') === 'super-admin'
              ? ''
              : `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          this.setState({
            country_list:
              localStorage.getItem('loged_In_role') == 'concierge'
                ? res.data.data.filter((ele) => ele.country_short_name === localStorage.getItem('countryShortName'))
                : res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  eventListData = async () => {
    this.setState({
      isSearching: true,
      open: true,
      eventData: [],
    })

    await axios
      .get(Constant.getAPI() + `/event/list-event-bookings`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: {
          keyword: this.state.keyword,

          // customer_phone: this.state.customer_phone,
          event_id: this.state.eventId?.value || '',
          bookingStatus: this.state.bookingStatus,
          country: this.state.country,
          type_tag: this.state.type_tag,
          booking_date: this.state.booking_date,

          pageNumber: this.state.pageNumber,
          limit: this.state.limit,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          this.setState({
            eventData: res?.data?.data,
            disabled: !res.data.data?.length > 0,
            open: false,
            totalCount: res.data.pagination?.count || 0,
            totalPages: res.data.pagination?.pages || 0,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
        this.setState({
          open: false,
        })
      })
      .finally(() => {
        this.setState({
          isSearching: false,
        })
      })
  }

  changeBookingTagAndStatus = async (event, rowData) => {
    let data = {}
    let id = rowData[0]
    let temp_data = this.state.eventData

    temp_data.forEach((itm) => {
      if (itm.id == id) {
        itm[event.target.name] = event.target.value

        data.event_id = itm.id
        data[event.target.name] = event.target.value
      }
    })

    this.setState({
      eventData: temp_data,
    })

    await axios
      .post(Constant?.getAPI() + `/event/update-booking-status`, data, {
        headers: {
          Authorization: `Bearer ${localStorage?.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          Swal.fire('Updated !', '', 'success')
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        })
      })
  }

  searchData = () => {
    this.setState(
      {
        pageNumber: 0,
      },
      () => {
        this.eventListData()
      }
    )
  }

  handleChange = (event) => {
    const fieldName = event.target.name
    const fieldValue = event.target.value

    this.setState({
      [fieldName]: fieldValue,
    })

    if (fieldName == 'country') {
      this.setState({
        eventList: [],
        eventId: '',
      })

      if (event.target.value != '') {
        this.getEventList(event.target.value)
      }
    }

    // Auto-search with debounce for all filters except keyword
    if (fieldName !== 'keyword') {
      this.triggerAutoSearch()
    } else {
      // Debounce keyword search
      this.triggerDebouncedSearch()
    }
  }

  clearFilters = () => {
    // Clear any pending debounce
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }

    this.setState(
      {
        limit: 10,
        pageNumber: 0,

        customer_phone: '',
        keyword: '',
        eventId: '',
        bookingStatus: '',
        country: '',
        type_tag: '',
        booking_date: '',

        eventData: [],
      },
      () => {
        // Auto-fetch data after clearing filters
        this.eventListData()
      }
    )
  }

  triggerDebouncedSearch = () => {
    // Clear existing timeout
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }

    // Set new timeout for keyword search (500ms delay)
    this.debounceTimeout = setTimeout(() => {
      this.setState(
        {
          pageNumber: 0,
        },
        () => {
          this.eventListData()
        }
      )
    }, 500)
  }

  triggerAutoSearch = () => {
    // Clear existing timeout
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }

    // Set new timeout for filter changes (300ms delay)
    this.debounceTimeout = setTimeout(() => {
      this.setState(
        {
          pageNumber: 0,
        },
        () => {
          this.eventListData()
        }
      )
    }, 300)
  }

  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      this.searchData()
    }
  }

  handleClear = () => {
    this.setState({ eventId: null })
  }

  handleEventChange = (event) => {
    this.setState({
      eventId: event,
    })
    // Auto-search when event changes
    this.triggerAutoSearch()
  }

  render() {
    const columns = [
      {
        name: 'id',
        label: 'id',
        options: {
          display: false,
        },
      },
      {
        name: 'order_number',
        label: 'Order No',
        options: {
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'event_name',
        label: 'Event Name',
        options: {
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'booking_date',
        label: 'Booking Date',
        options: {
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'booking_time',
        label: 'Booking Time',
        options: {
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'createdAt',
        label: 'Issue Date',
        options: {
          customBodyRender: (value) =>
            value ? (
              <div style={{ textWrap: 'nowrap' }}>{<Moment format="YYYY-MM-DD HH:mm A">{value}</Moment>}</div>
            ) : (
              '--'
            ),
        },
      },
      {
        name: 'customer_phone',
        label: 'Customer Phone',
        options: {
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'booking_amount',
        label: 'Booking Amount',
      },
      {
        name: 'catering_amount',
        label: 'Catering Amount',
        options: {
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'delivery_charge',
        label: 'Delivery Charge',
        options: {
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'wallet_amount_applied',
        label: 'Wallet Applied Amount',
      },
      {
        name: 'coupon_applied_amount',
        label: 'Coupon Applied Amount',
      },
      {
        name: 'coupon_code',
        label: 'Coupon code',
        options: {
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'ticket_booked',
        label: 'Adult Tickets',
        options: {
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'child_ticket_booked',
        label: 'Child Tickets',
        options: {
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'payment_status',
        label: 'Payment Status',
        options: {
          customBodyRender: (payment_status) => {
            return (
              <div>
                {payment_status === true ? (
                  <span className="badge badge-pill badge-success">Success</span>
                ) : (
                  <span className="badge badge-pill badge-warning">In Progress</span>
                )}
              </div>
            )
          },
        },
      },
      {
        name: 'payment_method',
        label: 'Payment Method',
        options: {
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'country',
        label: 'Country',
      },
      {
        name: 'booking_status',
        label: 'Booking Status',
        options: {
          customBodyRender: (value, { rowData }) => {
            return (
              <>
                <select
                  style={{ minWidth: 150 }}
                  name="booking_status"
                  className={`form-control
                      `}
                  value={value}
                  onChange={(event) => this.changeBookingTagAndStatus(event, rowData)}
                >
                  <option value="Pending">Pending</option>
                  <option value="Confirmed">Confirmed</option>
                  <option value="Successful">Successful</option>
                  <option value="Postponed">Postponed</option>
                  <option value="Cancelled">Cancelled</option>
                </select>
              </>
            )
          },
        },
      },
      {
        name: 'type_tag',
        label: 'Type Tag',
        options: {
          customBodyRender: (value, { rowData }) => {
            return (
              <>
                <select
                  style={{ minWidth: 150 }}
                  name="type_tag"
                  className="form-control"
                  value={value}
                  onChange={(event) => this.changeBookingTagAndStatus(event, rowData)}
                >
                  <option value={''}>N/A</option>
                  {getTypeTags().map((itm) => (
                    <option
                      value={itm}
                      key={itm}
                    >
                      {itm}
                    </option>
                  ))}
                </select>
              </>
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Action',
        options: {
          customBodyRender: (id) => {
            return (
              <div>
                <Link to={'/new-evt/' + id}>
                  <span
                    className="pointer"
                    style={{ cursor: 'pointer' }}
                  >
                    <i className="f-22 icofont icofont-eye text-dark"></i>
                  </span>
                </Link>
              </div>
            )
          },
        },
      },
    ]

    const options = {
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: true,
      search: false,
      filter: false,
      count: this.state.totalCount,
      page: this.state.pageNumber,
      rowsPerPage: this.state.limit,
      selectableRows: 'none',
      // setRowProps: (row) => {
      //   let basketData = getBasketSizeLimits(row[11], 'c')
      //   if (row[7] + row[8] + row[9] > basketData.max) {
      //     return {
      //       style: { background: basketData.maxColor },
      //     }
      //   } else if (row[7] + row[8] + row[9] < basketData.min) {
      //     return {
      //       style: { background: basketData.minColor },
      //     }
      //   }
      // },
      onDownload: (buildHead, buildBody, columns, values) => {
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        const fileExtension = '.xlsx'
        const fileName = `Event_Bookings`

        const json = values.reduce((result, val) => {
          const temp = {}
          val.data.forEach((v, idx) => {
            if (columns[idx].name == 'createdAt') {
              temp[columns[idx].label] = v
                ? moment(v)
                  .tz(getCountryTimeZone(localStorage.getItem('countryShortName')))
                  .format('YYYY-MM-DD HH:mm:ss')
                : ''
            } else if (columns[idx].label != 'Edit Booking' && columns[idx].label != 'Action') {
              temp[columns[idx].label] = v
            }
          })
          result.push(temp)
          return result
        }, [])

        const ws = utils.json_to_sheet(json)
        const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
        const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' })
        const blob = new Blob([excelBuffer], { type: fileType })
        const file = new File([blob], fileName + fileExtension, { type: fileType })

        const downloadLink = document.createElement('a')
        downloadLink.href = URL.createObjectURL(file)
        downloadLink.download = file.name

        downloadLink.click()

        // cancel default  CSV download from table
        return false
      },

      customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
        return (
          <CustomFooter
            changePage={changePage}
            changeRowsPerPage={changeRowsPerPage}
            disabled={this.state.disabled}
            count={this.state.limit}
            pageNumber={this.state.pageNumber}
            totalPages={this.state.totalPages}
          />
        )
      },
      onChangePage: (currentPage) => {
        this.setState(
          {
            pageNumber: currentPage,
          },
          () => this.eventListData()
        )
      },
      onChangeRowsPerPage: (numberOfRows) => {
        this.setState(
          {
            limit: numberOfRows,
            pageNumber: 0,
          },
          () => this.eventListData()
        )
      },
      textLabels: {
        body: {
          noMatch: this.state.open ? <Loader open={this.state.open} /> : 'Sorry, No Booking Data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <>
        <div className="page-body">
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-border-default">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group row">
                        <label className="col-md-3 col-form-label">Search</label>
                        <div className="col-md-9">
                          <input
                            type="text"
                            id="keyword"
                            className="form-control"
                            value={this.state.keyword}
                            name="keyword"
                            placeholder="Order No | Customer Phone/Email | Order Reference Id"
                            onKeyPress={this.handleKeyPress}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-12"
                      style={{ borderBottom: '2px solid #ddd', marginBottom: 16 }}
                    ></div>
                    <div className="col-md-4">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Booking Status</label>
                        <div className="col-sm-9">
                          <select
                            name="bookingStatus"
                            className="form-control"
                            value={this.state.bookingStatus}
                            onChange={this.handleChange}
                          >
                            <option value={''}>All</option>
                            <option value={'Pending'}>Pending</option>
                            <option value={'Successful'}>Successful</option>
                            <option value={'Cancelled'}>Cancelled</option>
                            <option value={'Confirmed'}>Confirmed</option>
                            <option value={'Postponed'}>Postponed</option>
                            <option value={'Incomplete'}>Incomplete</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Country</label>
                        <div className="col-sm-9">
                          <select
                            name="country"
                            className="form-control"
                            value={this.state.country}
                            onChange={this.handleChange}
                          >
                            <option value={''}>All</option>
                            {this.state.country_list.map((country) => (
                              <option
                                value={country.country_short_name}
                                key={country.country_short_name}
                              >
                                {country.country_name_en + '/' + country.country_name_ar}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Event Name</label>
                        <div className="col-sm-9">
                          <Select
                            name="eventId"
                            value={this.state.eventId}
                            onChange={this.handleEventChange}
                            options={this.state.eventList}
                            isMulti={false}
                            isSearchable={true}
                            isClearable
                            onClear={this.handleClear}
                            placeholder="Select Options"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Type Tag</label>
                        <div className="col-sm-9">
                          <select
                            name="type_tag"
                            className="form-control"
                            value={this.state.type_tag}
                            onChange={this.handleChange}
                          >
                            <option value={''}>All</option>
                            {getTypeTags().map((itm) => (
                              <option
                                value={itm}
                                key={itm}
                              >
                                {itm}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group row">
                        <label className="col-md-3 col-form-label">Booking Date</label>
                        <div className="col-md-9">
                          <input
                            type="date"
                            id="booking_date"
                            className="form-control"
                            value={this.state.booking_date || ''}
                            name="booking_date"
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    {/* <div className="col-md-4">
                      <div className="form-group row">
                        <label className="col-md-3 col-form-label">Customer Phone</label>
                        <div className="col-md-9">
                          <input
                            type="number"
                            id="customer_phone"
                            className="form-control"
                            value={this.state.customer_phone}
                            name="customer_phone"
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    <div className="col-md-12">
                      <div className="form-group row">
                        <div className="col-12">
                          <Button
                            disabled={this.state.isSearching}
                            onClick={this.searchData}
                          >
                            {this.state.isSearching ? 'Searching...!' : 'Search'}
                          </Button>
                          <Button
                            disabled={this.state.isSearching}
                            onClick={this.clearFilters}
                            variant="outlined"
                          >
                            clear
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="page-body">
          <div className="row">
            <div className="col-sm-12">
              <div className="dt-responsive table-responsive">
                <MUIDataTable
                  title={'Event Booking List'}
                  className="table-responsive"
                  data={this.state.eventData}
                  columns={columns}
                  options={options}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default NewEventList
